import { cB, c } from '../../../_utils/cssr';
export default c([cB('input-number-suffix', `
 display: inline-block;
 margin-right: 10px;
 `)]);